<template>
  <el-form
    label-width="100px"
    :inline="true"
    :model="form"
    class="demo-form-inline"
  >
    <el-form-item label="用户电话" required>
      <el-input v-model="form.phone" clearable />
    </el-form-item>

    <el-form-item label="用户名" required>
      <el-input v-model="form.username" clearable />
    </el-form-item>
    <el-form-item label="收货电话" required>
      <el-input v-model="form.address_phone" clearable />
    </el-form-item>
    <el-form-item label="收货人" required>
      <el-input v-model="form.address_name" clearable />
    </el-form-item>
    <el-form-item label="收货省市区" required>
      <el-input v-model="form.address_city" clearable />
    </el-form-item>
    <el-form-item label="详细地址" required>
      <el-input v-model="form.address_place" clearable />
    </el-form-item>
    <el-form-item label="发货状态" required>
      <el-select v-model="form.status" placeholder="" clearable>
        <el-option
          v-for="item in sendStatusEnums"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { getCurrentInstance, nextTick, onMounted, ref } from "vue";
import { rolesEnums, sendStatusEnums } from "@/config/enums";
import { getTokenAUTH } from "@/utils/auth";

const form = ref({
  phone: "",
  username: "",
  status: "",
  address_phone: "",
  address_name: "",
  address_city: "",
  address_place: "",
});
const props = defineProps(["item"]);

const headers = ref({})
onMounted(() => {
  headers.value['Accept-Token'] = getTokenAUTH()
  nextTick(() => {
    form.value = Object.assign(form, props.item);
  });
});
const { proxy } = getCurrentInstance()

const successUpload = (res) => {
  form.value.img = res.data.url;
};

const handleErr = (err) => {
  if (err.status == 320) {
    form.value.img = JSON.parse(err.message).data.url;
  }
}

defineExpose({ form });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}
.demo-form-inline .el-input {
  --el-input-width: 220px;
}

.demo-form-inline .el-select {
  --el-select-width: 220px;
}
/deep/ .el-radio-group {
  width: 220px;
}
.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}
/deep/ .el-form-item {
  align-items: flex-start;
}
</style>
